import styled from "styled-components";
import { FC } from "react";

import {
  getIconSizeValue,
  Icon,
  IconName,
  IconSize,
  IconVariant,
} from "../../Icon";

export type IconVariantArgs = {
  isSelected?: boolean;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  isFocused?: boolean;
  menuIsOpen?: boolean;
};

const getIconVariant = ({
  isDisabled,
  isFocused,
  isReadOnly,
  isSelected,
  menuIsOpen,
}: IconVariantArgs): IconVariant => {
  if (isSelected || isFocused || menuIsOpen) {
    return "ACTIVE";
  }
  if (isDisabled || isReadOnly) {
    return "DISABLED";
  }
  return "DEFAULT";
};

type StyledLabelWithIconProps = {
  $iconSize: number;
};

const StyledLabelWithIcon = styled.div<StyledLabelWithIconProps>`
  display: flex;
  gap: 4px;
  align-items: ${({ $iconSize }): string =>
    $iconSize < 16 ? "baseline" : "center"};
`;

type LabelWithIconProps = {
  allowIcons: boolean;
  iconName?: IconName;
  iconSize?: IconSize;
  IconVariantArgs?: IconVariantArgs;
  children?: React.ReactNode;
};

export const LabelWithIcon: FC<LabelWithIconProps> = ({
  iconName,
  iconSize = "small",
  allowIcons,
  IconVariantArgs,
  children,
}) => (
  <StyledLabelWithIcon $iconSize={getIconSizeValue(iconSize)}>
    {allowIcons && iconName && (
      <Icon
        iconName={iconName}
        iconSize={iconSize}
        variant={getIconVariant(IconVariantArgs || {})}
        plain
      />
    )}
    <div>{children}</div>
  </StyledLabelWithIcon>
);
